import React from "react";
import SectionTitle from "../SectionTitle/SectionTitle";
import { Link } from "react-router-dom";
import blogs from "../../api/blogs";

const ClickHandler = () => {
    window.scrollTo(10, 0);
};

const CausesSectionS3 = () => {
    return (
        <section className="wpo-causes-section-s2 section-padding">
            <div className="causes-wrap">
                <div className="container">
                    <div className="row justify-content-center ">
                        
                    </div>
                    <div className=" blogscontainer">
                        <div className="portrait">
                            {blogs.slice(0, 1).map((cause, index) => (
                                <div key={index} className="causes-item portrait">
                                    <div className="image">
                                        <img className="portrait" src={cause.screens} alt={cause.title} />
                                    </div>
                                    <div className="content">
                                        <h2><Link onClick={ClickHandler} to={`/news/${cause.slug}`}>{cause.title}</Link></h2>
                                        <p className="p-0 m-0"><i className="fi flaticon-calendar mx-1"></i> {cause.create_at}</p>
                                        <p>{cause.subtitle}</p>

                                    { 
                                    //#region progress item
                                        /* <div className="progress-item">
                                            <div className="progress">
                                                <div className="bar" style={{ width: `${(cause.raisedAmount / cause.goalAmount) * 100}%` }}></div>
                                            </div>
                                            <span className="cssProgress-label">{((cause.raisedAmount / cause.goalAmount) * 100).toFixed(2)}%</span>
                                            <div className="progres-label">
                                                <div className="label-on">
                                                    <p>Raised:<span>${cause.raisedAmount}</span></p>
                                                </div>
                                                <div className="label-two">
                                                    <p>Goal:<span>${cause.goalAmount}</span></p>
                                                </div>
                                            </div>
                                        </div> */
                                        //#endregion 
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="landscape">
                            {blogs.slice(1, 2).map((cause, index) => (
                                <div key={index} className="causes-item landscape">
                                    <div className="image">
                                        <img src={cause.screens} alt={cause.title} />
                                    </div>
                                    <div className="content">
                                        <h2><Link to={`/news/${cause.slug}`} onClick={ClickHandler}>{cause.title}</Link></h2>
                                        <p className="p-0 m-0"><i className="fi flaticon-calendar  mx-1"></i> {cause.create_at}</p>

                                        <p>{cause.subtitle}</p>
                                        {
                                        
                                        //#region progress item
                                        /* <div className="progress-item">
                                            <div className="progress">
                                                <div className="bar" style={{ width: `${(cause.raisedAmount / cause.goalAmount) * 100}%` }}></div>
                                            </div>
                                            <span className="cssProgress-label">{((cause.raisedAmount / cause.goalAmount) * 100).toFixed(2)}%</span>
                                            <div className="progres-label">
                                                <div className="label-on">
                                                    <p>Raised:<span>${cause.raisedAmount}</span></p>
                                                </div>
                                                <div className="label-two">
                                                    <p>Goal:<span>${cause.goalAmount}</span></p>
                                                </div>
                                            </div>
                                        </div> */
                                        //#endregion
                                        }
                                    </div>
                                </div>
                            ))}
                            {blogs.slice(2, 3).map((cause, index) => (
                                <div key={index} className="causes-item">
                                    <div className="image">
                                        <img src={cause.screens} alt={cause.title} />
                                    </div>
                                    <div className="content">
                                        <h2><Link to={`/news/${cause.slug}`} onClick={ClickHandler}>{cause.title}</Link></h2>
                                                                                <p className="p-0 m-0"><i className="fi flaticon-calendar  mx-1"></i> {cause.create_at}</p>

                                        <p>{cause.subtitle}</p>
                                        {
                                        
                                        //#region progress item
                                        /* <div className="progress-item">
                                            <div className="progress">
                                                <div className="bar" style={{ width: `${(cause.raisedAmount / cause.goalAmount) * 100}%` }}></div>
                                            </div>
                                            <span className="cssProgress-label">{((cause.raisedAmount / cause.goalAmount) * 100).toFixed(2)}%</span>
                                            <div className="progres-label">
                                                <div className="label-on">
                                                    <p>Raised:<span>${cause.raisedAmount}</span></p>
                                                </div>
                                                <div className="label-two">
                                                    <p>Goal:<span>${cause.goalAmount}</span></p>
                                                </div>
                                            </div>
                                        </div> */
                                        //#endregion
                                        }
                                    </div>
                                </div>
                            ))}
                            {/* <div className="causes-item-btn">
                                <Link to="/causes-single" className="causes-btn" onClick={ClickHandler} >See All Causes <i className="flaticon-right-arrow-2"></i></Link>
                            </div> */}
                        </div>
                        
                    </div>

                    <div className=" blogscontainer mt-5">
                        <div className="landscape">
                            {blogs.slice(3, 4).map((cause, index) => (
                                <div key={index} className="causes-item landscape">
                                    <div className="image">
                                        <img src={cause.screens} alt={cause.title} />
                                    </div>
                                    <div className="content">
                                        <h2><Link to={`/news/${cause.slug}`} onClick={ClickHandler}>{cause.title}</Link></h2>
                                        <p className="p-0 m-0"><i className="fi flaticon-calendar  mx-1"></i> {cause.create_at}</p>

                                        <p>{cause.subtitle}</p>
                                        {
                                        
                                        //#region progress item
                                        /* <div className="progress-item">
                                            <div className="progress">
                                                <div className="bar" style={{ width: `${(cause.raisedAmount / cause.goalAmount) * 100}%` }}></div>
                                            </div>
                                            <span className="cssProgress-label">{((cause.raisedAmount / cause.goalAmount) * 100).toFixed(2)}%</span>
                                            <div className="progres-label">
                                                <div className="label-on">
                                                    <p>Raised:<span>${cause.raisedAmount}</span></p>
                                                </div>
                                                <div className="label-two">
                                                    <p>Goal:<span>${cause.goalAmount}</span></p>
                                                </div>
                                            </div>
                                        </div> */
                                        //#endregion
                                        }
                                    </div>
                                </div>
                            ))}
                            {blogs.slice(4, 5).map((cause, index) => (
                                <div key={index} className="causes-item">
                                    <div className="image">
                                        <img src={cause.screens} alt={cause.title} />
                                    </div>
                                    <div className="content">
                                        <h2><Link to={`/news/${cause.slug}`} onClick={ClickHandler}>{cause.title}</Link></h2>
                                            <p className="p-0 m-0"><i className="fi flaticon-calendar  mx-1"></i> {cause.create_at}</p>

                                        <p>{cause.subtitle}</p>
                                        {
                                        
                                        //#region progress item
                                        /* <div className="progress-item">
                                            <div className="progress">
                                                <div className="bar" style={{ width: `${(cause.raisedAmount / cause.goalAmount) * 100}%` }}></div>
                                            </div>
                                            <span className="cssProgress-label">{((cause.raisedAmount / cause.goalAmount) * 100).toFixed(2)}%</span>
                                            <div className="progres-label">
                                                <div className="label-on">
                                                    <p>Raised:<span>${cause.raisedAmount}</span></p>
                                                </div>
                                                <div className="label-two">
                                                    <p>Goal:<span>${cause.goalAmount}</span></p>
                                                </div>
                                            </div>
                                        </div> */
                                        //#endregion
                                        }
                                    </div>
                                </div>
                            ))}
                            {/* <div className="causes-item-btn">
                                <Link to="/causes-single" className="causes-btn" onClick={ClickHandler} >See All Causes <i className="flaticon-right-arrow-2"></i></Link>
                            </div> */}
                        </div>

                        <div className="portrait">
                            {blogs.slice(5, 6).map((cause, index) => (
                                <div key={index} className="causes-item portrait">
                                    <div className="image">
                                        <img className="portrait" src={cause.screens} alt={cause.title} />
                                    </div>
                                    <div className="content">
                                        <h2><Link onClick={ClickHandler} to={`/news/${cause.slug}`}>{cause.title}</Link></h2>
                                        <p className="p-0 m-0"><i className="fi flaticon-calendar mx-1"></i> {cause.create_at}</p>
                                        <p>{cause.subtitle}</p>

                                    { 
                                    //#region progress item
                                        /* <div className="progress-item">
                                            <div className="progress">
                                                <div className="bar" style={{ width: `${(cause.raisedAmount / cause.goalAmount) * 100}%` }}></div>
                                            </div>
                                            <span className="cssProgress-label">{((cause.raisedAmount / cause.goalAmount) * 100).toFixed(2)}%</span>
                                            <div className="progres-label">
                                                <div className="label-on">
                                                    <p>Raised:<span>${cause.raisedAmount}</span></p>
                                                </div>
                                                <div className="label-two">
                                                    <p>Goal:<span>${cause.goalAmount}</span></p>
                                                </div>
                                            </div>
                                        </div> */
                                        //#endregion 
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
            
                </div>
            </div>
        </section>
    );
};

export default CausesSectionS3;
